import { Flow } from 'signup-constants/Flow';
import { getIntentKey } from '../routing/getIntentKey';
import { getIsNewUser, getIsOAuthExistingUser } from '../store/app/selectors';
import { isFlow } from '../utils/isFlow';
import { ExperimentKeys, TEST_KEY } from './ExperimentKeys';
import { getIsNewUserExperiment } from './ExperimentUtils';
import { getIsComingFromEmailSignatureGenerator } from './acq0139/acq0139Utils';
import { enrollOnFlow } from './experimentDefaults';
export const EXPERIMENT_ID = 'experimentId';
const SEEN_EXPERIMENTS = new Set();
const Experiments = new Map([[ExperimentKeys.ACQ0134, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Marketing, Flow.Sales, Flow.Service]);
    const isNewUser = getIsOAuthExistingUser(state) || getIsNewUserExperiment(state);
    const intentKey = getIntentKey();
    const isComingFromEmailSignatureGenerator = getIsComingFromEmailSignatureGenerator();
    return isEnrolledFlow && isNewUser && !intentKey && !isComingFromEmailSignatureGenerator;
  }
}], [ExperimentKeys.ONBU0025, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service, Flow.CmsFree]);
    const isNewUser = getIsNewUser(state);
    return isEnrolledFlow && isNewUser;
  }
}], [ExperimentKeys.CSFE0014, {
  shouldEnroll: state => {
    return isFlow(Flow.CmsFree) && getIsNewUserExperiment(state);
  }
}], [ExperimentKeys.ACQ0140, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const isNewUser = getIsOAuthExistingUser(state) || getIsNewUserExperiment(state);
    const intentKey = getIntentKey();
    const isComingFromEmailSignatureGenerator = getIsComingFromEmailSignatureGenerator();
    return isEnrolledFlow && isNewUser && !intentKey && !isComingFromEmailSignatureGenerator;
  }
}]]);
export const getExperiment = id => {
  // we want to prefer this solution over mocking getExperiment so that the
  // seen experiments tracking below continues to work and doesn't get
  // accidentally mocked
  if (id === TEST_KEY) {
    return {
      shouldEnroll: () => enrollOnFlow([Flow.Crm])
    };
  }

  SEEN_EXPERIMENTS.add(id);
  return Experiments.get(id);
};
export function getSeenExperimentsForTesting() {
  return Array.from(SEEN_EXPERIMENTS);
}